// Footer.jsx
// import React from "react";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaMapMarkerAlt,
//   FaPhone,
//   FaEnvelope
// } from "react-icons/fa";
// import { logo } from "../_components/Imagepath";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="bizmark-footer">
      {/* <div className="footer-main">
        <div className="footer-grid">

          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="BizzMark India Logo" />
            </div>

            <h4 className="footer-brand-tagline">
              One-stop for all local services across India
            </h4>

            <p className="footer-brand-desc">
              BizMark is a trusted local business discovery platform that helps
              users find verified services across categories. We connect
              customers with reliable professionals quickly and securely.
            </p>

            <div className="footer-social">
              <a
                href="https://www.facebook.com/bizzmarkindia"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>

              <a
                href="https://www.instagram.com/bizzmarkindia/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>


            </div>
          </div>


          <div className="footer-column">
            <h3>Categories</h3>
            <ul className="footer-links">
              <li><a href="/category/restaurants">Restaurants</a></li>
              <li><a href="/category/beauty-spa">Beauty Spa</a></li>
              <li><a href="/category/wedding-planning">Wedding Planning</a></li>
              <li><a href="/category/education">Education</a></li>
              <li><a href="/category/pg-hostels">PG / Hostels</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Get In Touch</h3>
            <ul className="footer-contact-list">
              <li className="contact-item">
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <span>
                  SF-6, Shivalaya Complex, 2nd Floor, Vasna–Tandalja Rd,
                  Ashwamegh Nagar, Vasna, Vadodara, Gujarat 390007
                </span>
              </li>

              <li className="contact-item">
                <div className="contact-icon">
                  <FaPhone />
                </div>
                <a href="tel:+919967956503">+91 9601961116</a>
              </li>

              <li className="contact-item">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <a href="mailto:info@bizmark.in">info@bizzmarkindia.com</a>
              </li>
            </ul>
          </div>

        </div>

        <div className="footer-divider"></div>
      </div> */}

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            © {new Date().getFullYear()} BizzMark India. All Rights Reserved.
          </p>

          <div className="footer-bottom-links">
            {/* <a href="/sitemap">Sitemap</a> */}
            {/* <a href="/support">Support</a> */}
            {/* <a href="/faqs">FAQs</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;